import * as React from 'react';
import { Form, Dropdown, Label } from 'semantic-ui-react';

interface Props {
    input: {
        value: any;
        onBlur: Function;
        onChange: Function;
        multiple?: boolean;
    };
    label?: number | string;
    placeholder?: string;
    meta: {
        touched?: boolean;
        error?: string;
    };
    options: Record<string, any>[];
    renderOptions?: React.ReactNode;
    multiple?: boolean;
    nullOnUnmount?: boolean;
    name: string;
}

export default class RenderDropdown extends React.PureComponent<Props> {
    // eslint-disable-next-line react/static-property-placement
    static defaultProps = {
        nullOnUnmount: true
    };

    componentDidMount(): void {
        this.clearInputIfValueDoesntExistInOptions();
    }

    componentDidUpdate(): void {
        this.clearInputIfValueDoesntExistInOptions();
    }

    componentWillUnmount(): void {
        const { input, nullOnUnmount } = this.props;
        if (nullOnUnmount) {
            input.onChange(null);
        }
    }

    get multiple(): boolean {
        const { input, multiple } = this.props;

        // Support redux-form and react-final-form
        return !!(input.multiple || multiple);
    }

    clearInputIfValueDoesntExistInOptions(): void {
        const {
            input: { value, onChange },
            options
        } = this.props;

        // Clear input value if it doen't exist in options
        if (
            !this.multiple &&
            value &&
            !options.some(
                (option) => option.key === value || option.value === value
            )
        ) {
            setTimeout(() => {
                // HACK: This is for specific case when onChange itself does not update the Form Field state immediately
                // TODO: https://stackoverflow.com/questions/65084257/react-final-form-input-onchangenull-does-not-update-state-immediately
                onChange(null);
            }, 0);
        }
    }

    render(): React.ReactElement {
        const {
            input: { value, ...input },
            label,
            meta: { touched, error },
            renderOptions,
            nullOnUnmount,
            name,
            ...props
        } = this.props;

        return (
            <Form.Field
                style={{ position: 'relative' }}
                error={!!(touched && error)}
            >
                {label && (
                    <label htmlFor={name} style={{ display: 'inline-block' }}>
                        {label}
                    </label>
                )}
                {renderOptions && renderOptions}
                <Dropdown
                    {...props}
                    {...input}
                    value={value}
                    multiple={this.multiple}
                    onChange={(param: any, data: any): void => {
                        input.onChange(data.value);
                    }}
                    onBlur={(event: any): void => {
                        event.preventDefault();
                    }}
                    lazyLoad
                />
                {!!(touched && error) && (
                    <Label basic color="red" pointing>
                        {error}
                    </Label>
                )}
            </Form.Field>
        );
    }
}
